import React, { Component } from "react";
import { Form, RadioGroup, Radio, Text } from "informed";
import { Row, Col } from "reactstrap";
import { AiOutlineBank, AiOutlineCreditCard, AiOutlineMobile, AiOutlineQrcode } from "react-icons/ai";
import { MdPayment } from "react-icons/md";
import { BiPlus, BiSearch } from "react-icons/bi";
import { FaInfoCircle } from "react-icons/fa";
import { IoMdBoat } from "react-icons/io";
import { Collapse, Skeleton } from "antd";
import Countdown from "react-countdown";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { format } from "date-fns";
import NavBar from "../../common/forms/NavbarCopy";
import "./PaymentPage.scss";
import "./PaymentResponsive.scss";
import upi from "../../../images/boat/logos/upi.svg";
import gpay from "../../../images/boat/logos/gpay.svg";
import paytm from "../../../images/boat/logos/paytm.svg";
import phonepe from "../../../images/boat/logos/phonepe-logo.svg";
import sbi from "../../../images/boat/logos/sbi.svg";
// import qrpng from "../../../images/50.png";
import { TextInput } from "../../forms";
import { validateProperty } from "../../Validation/JoiValidation";
import { getPaymentBanks, getSMSLink, postSuccessOnlineBookingAfterTrans, getQRSMSReference } from "../../../services/paymentPageservice";
import subDirectory from "../../../config.json";
import paymentGatwayURIC from "../../../config.json";

import { getLocalStorageValues } from "../../../services/authService";
import { sendUPIsms } from "../../../services/boatListService";
import { AddNotification } from "../../Methods/Notificaition";
import { Loader } from "../../common/forms/Loading";
import { getCookieData, removeCookieData, storeCookieData } from "../../../services/boat";
import WorkerBuilder from "../../../services/worker/workerBuilder";
// import GetConfirmation from "../../../services/worker/paymentService.worker";
// import successIcon from "../../../images/success.gif";
import { QRCode } from 'react-qrcode-logo';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { setLocalStorevalue } from '../../../services/authService';

const { Panel } = Collapse;



const worker = new Worker("../../../services/worker/paymentService.worker.js")

export default class PaymentPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openNotification: false,
            loadingDebit: false,
            loadingCredit: false,
            loadingNet: false,
            NetBankingList: [],
            DebitBankingList: [],
            CreditBankingList: [],
            selectedPaymentMode: "NET",
            selectedPaymentModeId: "OPTNBK",
            // selectedPaymentMode: "UPI",
            showQr: false,
            // selectedPaymentModeId: "",
            selectedDebitBank: "",
            selectedDebitBankId: "",
            selectedCreditBank: "",
            selectedCreditBankId: "",
            selectedNetBank: "",
            selectedNetBankId: "",
            isOpenDebit: true,
            isOpenCredit: true,
            isOpenNet: false,
            PaymentData: {},
            isAlertModal: false,
            Time: "",
            isUpiModel: false,
            isUpiSmsSend: false,
            qrLink: "hi",
            referenceNo: "",
            mobileNo: "",
            BankReferenceNo: "",
            PaymentState: false,
            resendButton: false,
            key: 0
        };
    }
    componentDidMount = async () => {
        // this.instance = new WorkerBuilder(GetConfirmation);
        // new Worker(new URL('../', import.meta.url));

        // console.log(this.props, "propsss");
        if (this.props?.location?.state) {
            let Time = getCookieData("Time");
            // console.log(Time, "cookieeTime");
            await this.setState({ PaymentData: this.props.location.state });
            await this.setState({ loadingCredit: true, loadingDebit: true, loadingNet: true });
            await this.getDebitCardBanking();
            await this.getCreditCardBanking();
            await this.getNetBanking();
            if (Time) {
                await this.setState({ Time: Time });
            } else {
                await this.setState({ Time: 240000 });
            }
            this.showQrFun();
            worker.onmessage = async (message) => {
                // console.log('message to main', message)
                if (message) {

                    // console.log("Message from worker", message.data, message.data[0].BankReferenceNo);
                    await this.setState({ BankReferenceNo: message.data[0].BankReferenceNo })
                    this.setState({ PaymentState: true })
                    // this.callRedirectToBookingFunLater();

                    this.redirectToBookingPage();
                }
            };
            worker.onerror = (evt) => console.log(`worker failed ${evt}`);
        } else {
            this.props.history.push({
                pathname: `${subDirectory}/boat`,
            });
        }
    };
    // callRedirectToBookingFunLater = () => { setTimeout(this.redirectToBookingPage, 3000)};

    redirectToBookingPage = async () => {
        const { PaymentData, BankReferenceNo } = this.state;
        let afterData = {
            TransactionNo: PaymentData.BookingId,
            UserId: `${getLocalStorageValues("UserId")}`,
            MobileNo: `${getLocalStorageValues("MobileNo")}`,
            EmailId: `${getLocalStorageValues("EmailId")}`,
            BankReferenceNo: BankReferenceNo,
            BookingType: "B",
            BoatHouseId: PaymentData.BoatHouseId,
            BookingMedia: "PW",
            OrderStatus: "Success",
            ModuleType: "Boating",
            OrderId: "",
            TrackingId: "",
        };
        // const ares = await bookingAfterTransaction(afterData)
        // console.log("afterData", afterData);
        const ares = await postSuccessOnlineBookingAfterTrans(afterData)
        // console.log('ares', ares);
        if (ares.data.StatusCode === 1) {
            // return window.location.href = `${subDirectory}/boatBookingHistory`
            // return <Redirect push to="/boatBookingHistory" />
            // console.log("pathname", subDirectory.subDirectory+'/boatBookingHistory')
            // this.props.history.push({pathname: `${subDirectory.subDirectory}/boatBookingHistory`});
            let date = new Date();
            date = date.toLocaleDateString().split('/')
            date = date[1] + '/' + date[0] + '/' + date[2]
            // console.log('bookingId',ares.data.Response.split('~')[2], PaymentData.BoatHouseId, date)
            // setLocalStorevalue("BookingId", ares.data.Response.split('~')[2])
            // console.log("pathname ", `${subDirectory.subDirectory}/booking-receipt?BoatHouseId=${PaymentData.BoatHouseId}&BookingId=${ares.data.Response.split('~')[2]}&BookingDate=${date}&BookingType=B`)
            this.props.history.push({
                // pathname: `${subDirectory.subDirectory}/booking-receipt`,
                // search: `?BoatHouseId=${PaymentData.BoatHouseId}&BookingId=${ares.data.Response.split('~')[2]}&BookingDate=${date}&BookingType=B`
                pathname: `${subDirectory.subDirectory}/boatPaymentSucess`,
                state: {
                    BoatHouseId: PaymentData.BoatHouseId,
                    BookingId: ares.data.Response.split('~')[2],
                    BookingDate: date,
                    BookingType: "B"
                },
            });
        }
    }
    getNetBanking = async () => {
        let data = {
            PaymentMode: "NetBanking",
        };
        const res = await getPaymentBanks(data);
        // console.log(res.data.Response, "netBanking");
        if (res.data.StatusCode == 1 && res.data.Response.length > 1) {
            await this.setState({ NetBankingList: res.data.Response });
        } else {
            await this.setState({ NetBankingList: [] });
        }
        await this.setState({ loadingNet: false });
    };
    getDebitCardBanking = async () => {
        let data = {
            PaymentMode: "DebitCard",
        };
        const res = await getPaymentBanks(data);
        // console.log(res, "DebitCard");
        if (res.data.StatusCode == 1 && res.data.Response.length > 1) {
            await this.setState({ DebitBankingList: res.data.Response });
        } else {
            await this.setState({ DebitBankingList: [] });
        }
        await this.setState({ loadingDebit: false });
    };
    getCreditCardBanking = async () => {
        let data = {
            PaymentMode: "CreditCard",
        };
        const res = await getPaymentBanks(data);
        // console.log(res, "CreditCard");
        if (res.data.StatusCode == 1 && res.data.Response.length > 1) {
            await this.setState({ CreditBankingList: res.data.Response });
        } else {
            await this.setState({ CreditBankingList: [] });
        }
        await this.setState({ loadingCredit: false });
    };
    setFormApiUpi = (formApi) => (this.formApiUpi = formApi);
    setFormApiDebit = (formApi) => (this.formApiDebit = formApi);
    setFormApiCredit = (formApi) => (this.formApiCredit = formApi);
    setFormApiNet = (formApi) => (this.formApiNet = formApi);

    onChangePaymentMode = async (mode) => {
        //UPI, DEBIT,CREDIT, NET
        await this.setState({ selectedPaymentMode: mode });

        if (mode == "UPI") {
            return this.setState({ selectedPaymentModeId: "" });
        } else if (mode == "DEBIT") {
            return this.setState({ selectedPaymentModeId: "OPTDBCRD" });
        } else if (mode == "CREDIT") {
            return this.setState({ selectedPaymentModeId: "OPTCRDC" });
        } else if (mode == "NET") {
            return this.setState({ selectedPaymentModeId: "OPTNBK" });
        }
    };

    proceedToPay = (mode) => {
        const { PaymentData, selectedPaymentModeId } = this.state;
        let dataAccept = "";
        let issuingBank = "";
        let paymentOption = selectedPaymentModeId;
        if (mode == "DEBIT") {
            dataAccept = this.state.selectedDebitBankId;
            issuingBank = this.state.selectedDebitBank;
        } else if (mode == "CREDIT") {
            dataAccept = this.state.selectedCreditBankId;
            issuingBank = this.state.selectedCreditBank;
        } else if (mode == "NET") {
            dataAccept = this.state.selectedNetBankId;
            issuingBank = this.state.selectedNetBank;
        } else {
            return null;
        }
        // console.log(
        //   "url",
        //   `${paymentGatwayURIC.paymentGatwayURIC}/checkout?amt=${PaymentData?.TotalAmount}
        //    &userId=${getLocalStorageValues("UserId")}&mobileno=${getLocalStorageValues("MobileNo")}
        //   &email=${getLocalStorageValues("EmailId")}&HotelId=${PaymentData?.BoatHouseId}
        //   &BookingId=${PaymentData?.BookingId}&HotelName=${PaymentData?.BoatHouseName}
        //   &tripDate=${format(new Date(PaymentData?.TripDate), "dd/MM/yyyy")}
        //   &bookingType=${PaymentData?.BookingType}&resFileName=BoatPaymentHandler.html&paymentOption=${paymentOption}&dataAccept=${dataAccept}&issuingBank=${issuingBank}&shortName=${PaymentData?.shortName}`
        // );

        // setInterval(()=> {console.log("set interval")}, 5000);
        return (window.location.href = `${paymentGatwayURIC.paymentGatwayURIC}/checkout?amt=${PaymentData?.TotalAmount}
                &userId=${getLocalStorageValues("UserId")}&mobileno=${getLocalStorageValues("MobileNo")}
                &email=${getLocalStorageValues("EmailId")}&HotelId=${PaymentData?.BoatHouseId}
                &BookingId=${PaymentData?.BookingId}&HotelName=${PaymentData?.BoatHouseName}
                &tripDate=${format(new Date(PaymentData?.TripDate), "dd/MM/yyyy")}&BankName=${this.state.selectedNetBank}
                &bookingType={(${PaymentData?.OtherserviceCart?.length > 0}||${PaymentData?.ParkingList?.length > 0})?IB:${PaymentData?.BookingType}}&resFileName=BoatPaymentHandler.html&paymentOption=${paymentOption}&dataAccept=${dataAccept}&issuingBank=${issuingBank}&shortName=${PaymentData?.shortName}`);
    };
    // resend = async () => {
    //   await this.sendUPImsg
    // }
    sendUPImsg = async () => {
        await this.setState({ loading: true });
        const { PaymentData } = this.state;
        let formData = this.formApiUpi.getValues();
        let upidata = { ServiceType: "DUPI", BookingId: PaymentData.BookingId, MobileNo: formData.mobile, MediaType: "PW", BoatHouseId: PaymentData.BoatHouseId, BoatHouseName: PaymentData.BoatHouseName, Remarks: PaymentData.TotalAmount };
        const res = await sendUPIsms(upidata);
        if (res.data.StatusCode == 1) {
            await this.setState({
                loading: false,
                isUpiModel: true,
                isUpiSmsSend: true,
                referenceNo: res.data.Response,
                mobileNo: formData.mobile,
                key: this.state.key + 1
            });
            // console.log("key", this.state.key);


            // this commented because this is open in showQR function
            // instance.postMessage({
            //         "BoatHouseId": upidata.BoatHouseId,
            //         "ServiceType": upidata.BookingId,
            //         "QueryType": "TransactionNo",
            //         "BookingDate":""
            //   })
        } else {
            await this.setState({
                loading: false,
                isUpiModel: true,
                isUpiSmsSend: false,
                mobileNo: formData.mobile
            });
        }
        // console.log(res, "res");
    };

    upiOk = () => {
        this.setState({ isUpiModel: false });
        if (this.state.isUpiSmsSend) {
            this.props.history.push({
                pathname: `${subDirectory}/boat`,
            });
        }
    };
    Timerenderer = ({ hours, minutes, seconds, completed, total, ...rest }) => {
        if (completed) {
            // console.log("final", completed, total);
            storeCookieData("Time", 0);
            this.setState({ isAlertModal: true });
            worker.terminate()
            return (
                <span>
                    {0}:{0}
                </span>
            );
        } else {
            // console.log("minutes", minutes, seconds)
            // Render a countdown
            if (this.state.isAlertModal == false) {
                // console.log("checking", completed, total);
                storeCookieData("Time", total);
            }
            let color = "green"
            if (minutes < 1) {
                color = "red"
            }
            else if (minutes < 2) {
                color = "orange"
            }
            return (
                <span style={{ color: color }}>
                    {minutes}:{seconds}
                </span>
            );
        }
    };
    componentWillUnmount() {
        removeCookieData("Time");
    }

    showQrFun = async () => {
        // let mobileNumber = localStorage.getItem('MobileNo')
        const { PaymentData } = this.state;
        let upidata = { ServiceType: "DUPI", BookingId: PaymentData.BookingId, MobileNo: getLocalStorageValues("MobileNo"), MediaType: "PW", BoatHouseId: PaymentData.BoatHouseId, BoatHouseName: PaymentData.BoatHouseName, Remarks: PaymentData.TotalAmount };
        const res = await getQRSMSReference(upidata);
        if (res.data.StatusCode == 1) {
            await this.setState({
                referenceNo: res.data.Response,
                mobileNo: upidata.MobileNo
            });

            let data = {
                "MobileNo": getLocalStorageValues("MobileNo"),
                "ReferenceNo": this.state.referenceNo,
                "BoatHouseId": PaymentData.BoatHouseId
            }
            let qrLink = await getSMSLink(data)
            // console.log('qrlink', qrLink, qrLink.data.Response);

            this.setState({ qrLink: qrLink.data.Response.split('--')[0].split('clicking')[1].trim() })
            worker.postMessage({
                "BoatHouseId": upidata.BoatHouseId,
                "ServiceType": upidata.BookingId,
                "QueryType": "TransactionNo",
                "BookingDate": ""
            })


        }
        // console.log('payment data', PaymentData);

        // console.log('send sms data', data);

        // this.setState({showQr: true})
        // qrLink = qrLink.data.Response.split('--')[0].split("clicking")[-1]
        // console.log('qrLink',qrLink);
    }

    circularTimeConvert = ({ remainingTime }) => {
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60
        if (minutes > 3 && this.state.resendButton === true) {
            this.setState({ resendButton: false })
        }
        if (minutes < 1 && this.state.resendButton === false) {
            this.setState({ resendButton: true });
        }
        // console.log('circular minutes', minutes, seconds)
        // this.state.resendButton

        return <span style={{ fontSize: "36px" }}>{`${minutes}:${seconds}`}</span>
    }
    circularTimeComplete = () => {
        storeCookieData("Time", 0);
        this.setState({ isAlertModal: true });
        worker.terminate();

    }

    GoBack = () => {
        removeCookieData("Time");
        this.props.history.goBack();
    };
    render() {
        const { PaymentData, isOpenCredit, isOpenDebit, isOpenNet, DebitBankingList, NetBankingList, CreditBankingList, selectedCreditBank, selectedDebitBank, selectedNetBank, selectedCreditBankId, selectedDebitBankId, selectedNetBankId } = this.state;
        {
            // console.log(this.state, "state");
        }
        return (
            <div className="PaymentPage">
                <AddNotification visible={this.state.openNotification} variant={this.state.variant} message={this.state.message} onClose={() => this.setState({ openNotification: false })} />
                <Loader fullPage loading={this.state.loading} />

                <NavBar {...this.props} />
                <div className="paymentdiv">
                    <div className="payment-container mt-5">
                        {/* {this.state.Time !== "" ? (
            <div className="timerdiv">
              <span>This Session will expire in </span>
              <span className="timercount">
                <Countdown date={Date.now() + Number(this.state.Time)} renderer={this.Timerenderer} />
              </span>
            </div>
          ) : (
            ""
          )} */}
                        <div className="d-flex payment-data">
                            <div className="payment-detail d-flex">
                                {/* <div className="payment-heading"> */}
                                <div className="payment-summary w-100">
                                    <div className="payment-title">
                                        <div className="boat-title">
                                            <IoMdBoat />
                                            &nbsp;
                                            {PaymentData?.BoatHouseName}
                                        </div>
                                        <div className="boat-amount">
                                            {" "}
                                            ₹ {PaymentData?.TotalAmount}
                                            <span className="to-pay">&nbsp;To Pay</span>
                                        </div>
                                    </div>

                                    <div className="payment-info mt-1">
                                        <div className="p-email">{getLocalStorageValues("EmailId")}</div>
                                        <div className="p-mobile">{getLocalStorageValues("MobileNo")}</div>
                                        {/* <div className="p-date">21/12/2021</div> */}
                                    </div>
                                    {/* <div className="wave text-end">
                  <span>This Session will expire in</span>
                  <span className="timercount"><Countdown date={Date.now() + 300000 } zeroPadTime={2} renderer={this.Timerenderer} /></span>
                </div> */}
                                    {/* <div className="wave">
                  <Wave
                    style={{ height: "15px", width: "100%" }}
                    fill="#15c200"
                    // fill="#58a6ff"
                    paused={false}
                    options={{
                      height: 2,
                      amplitude: 10,
                      speed: 0.25,
                      points: 4,
                    }}
                  />
                </div> */}
                                </div>
                                {/* </div> */}
                                <div className="payment-option w-100">
                                    <div class="row w-100">
                                        <div class="col-md-12 col-sm-12">
                                            <div class="tabs-left d-flex">
                                                <div className="tab-heading">
                                                    <ul class="nav nav-tabs">
                                                        <li className="p-heading">Payment options</li>
                                                        <li onClick={() => this.onChangePaymentMode("UPI")}>
                                                            <a href="#a" data-toggle="tab">
                                                                <div className="heading-content d-flex">
                                                                    <span className="heading-icon">
                                                                        <img src={upi} width="25px" alt="upi" />
                                                                    </span>
                                                                    <div className="heading-name">
                                                                        <span className="heading-title">UPI</span>
                                                                        <span className="heading-description">Google Pay,PhonePe & More </span>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>

                                                        <li onClick={() => this.onChangePaymentMode("UPI")}>
                                                            <a href="#q" data-toggle="tab">
                                                                <div className="heading-content d-flex">
                                                                    <span className="heading-icon">
                                                                        <AiOutlineQrcode />
                                                                    </span>
                                                                    <div className="heading-name">
                                                                        <span className="heading-title">UPI QR</span>
                                                                        <span className="heading-description">Google Pay,PhonePe & More </span>
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </li>

                                                        <li onClick={() => this.onChangePaymentMode("DEBIT")}>
                            <a href="#b" data-toggle="tab">
                              <div className="heading-content d-flex">
                                <span className="heading-icon">
                                  <MdPayment />
                                </span>
                                <div className="heading-name">
                                  <span className="heading-title">Debit/ATM Card</span>
                                  <span className="heading-description">Visa,MasterCard,Rupay & More</span>
                                </div>
                              </div>
                            </a>
                          </li>

                          <li onClick={() => this.onChangePaymentMode("CREDIT")}>
                            <a href="#c" data-toggle="tab">
                              <div className="heading-content d-flex">
                                <span className="heading-icon">
                                  <AiOutlineCreditCard />
                                </span>
                                <div className="heading-name">
                                  <span className="heading-title">Credit Card</span>
                                  <span className="heading-description">Visa,MasterCard,Rupay & More</span>
                                </div>
                              </div>
                            </a>
                          </li>
                          <li onClick={() => this.onChangePaymentMode("NET")}>
                            <a href="#d" class="active" data-toggle="tab">
                              <div className="heading-content d-flex">
                                <span className="heading-icon">
                                  <AiOutlineBank />
                                </span>
                                <div className="heading-name">
                                  <span className="heading-title">Net Banking</span>
                                  <span className="heading-description">All Indian banks </span>
                                </div>
                              </div>
                            </a>
                          </li>
                                                    </ul>
                                                </div>
                                                <div class="tab-content w-100">
                                                    <div class="tab-pane" id="a">
                                                        <div className="upi-data row">
                                                            <div className="upi-container row">
                                                                <Form id="upi-form" getApi={this.setFormApiUpi} className="" initialValues={{ mobile: getLocalStorageValues("MobileNo") }} onSubmit={this.sendUPImsg}>
                                                                    {({ formState, formApi }) => (
                                                                        <>
                                                                            <div className="upi-info">
                                                                                <span className="phone-icon">
                                                                                    <AiOutlineMobile />
                                                                                </span>
                                                                                <span className="phone-info">Keep your phone handy!</span>
                                                                            </div>
                                                                            <div className="upi-form">
                                                                                <Row className="mt-2">
                                                                                    <Col md={12}>
                                                                                        <TextInput field={`mobile`} label="Mobile No" className=" form-control-sm text-field-style" placeholder="Enter Mobile No" validateOnBlur validate={(value) => validateProperty(true, "contact", value, "Mobile No")} />
                                                                                    </Col>
                                                                                </Row>
                                                                                <div className="d-flex justify-content-center mt-3">
                                                                                    <button className=" upi-btn btn btn-success" type="submit">
                                                                                        Verify & pay
                                                                                    </button>
                                                                                </div>
                                                                                <div className="upi-note">
                                                                                    <span className="upi-info-icon mr-1">
                                                                                        <FaInfoCircle />
                                                                                    </span>
                                                                                    Payment link will send to above Mobile Number
                                                                                </div>
                                                                                <div className="upi-images mt-4">
                                                                                    <img src={phonepe} width="30px" className="phonepe" />
                                                                                    <img src={upi} width="30px" className="upi-logo" />
                                                                                    <img src={gpay} width="30px" className="gpay" />
                                                                                    <img src={sbi} width="30px" className="sbi" />
                                                                                    <img src={paytm} width="75px" className="paytm" />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </Form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane" id="q">
                                                        <div className="upi-data row">
                                                            <div className="upi-container row">

                                                                <div className="upi-info">
                                                                    <span className="phone-icon">
                                                                        <AiOutlineMobile />
                                                                    </span>
                                                                    <span className="phone-info">Keep your phone handy!</span>
                                                                </div>
                                                                <div className="upi-form">
                                                                    {/* {console.log('this.state', this.state.Time, this.state.PaymentState)} */}
                                                                    {this.state.Time !== "" && this.state.PaymentState === false ? (
                                                                        <div className="timerdiv" style={{ color: "black" }}>
                                                                            <span>Payment Session will expire in </span>
                                                                            <span className="timercount">
                                                                                <Countdown key={this.state.key} date={Date.now() + Number(this.state.Time)} renderer={this.Timerenderer} />
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                    <div style={{ marginLeft: "5.5rem" }}>
                                                                        <QRCode
                                                                            value={this.state.qrLink}
                                                                            // logoImage={qrpng}
                                                                        // removeQrCodeBehindLogo ={true}
                                                                        />
                                                                    </div>
                                                                    {/* <Row className="mt-2">
                                        <Col md={12}>
                                          <TextInput field={`mobile`} label="Mobile No" className=" form-control-sm text-field-style" placeholder="Enter Mobile No" validateOnBlur validate={(value) => validateProperty(true, "contact", value, "Mobile No")} />
                                        </Col>
                                      </Row> */}
                                                                    {/* <div className="d-flex justify-content-center mt-3">
                                        <button className=" upi-btn btn btn-success" type="submit">
                                          Verify & pay
                                        </button>
                                      </div> */}
                                                                    <div className="upi-note">
                                                                        <span className="upi-info-icon mr-1">
                                                                            <FaInfoCircle />
                                                                        </span>
                                                                        Scan QR to Make Payment
                                                                    </div>
                                                                    <div className="upi-images mt-4">
                                                                        <img src={phonepe} width="30px" className="phonepe" />
                                                                        <img src={upi} width="30px" className="upi-logo" />
                                                                        <img src={gpay} width="30px" className="gpay" />
                                                                        <img src={sbi} width="30px" className="sbi" />
                                                                        <img src={paytm} width="75px" className="paytm" />
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tab-pane" id="b">
                                                        <div className="net-banking-container">
                                                            <div className="net-banking-form ">
                                                                <Skeleton active loading={this.state.loadingDebit}>
                                                                    <Form id="atm-form" getApi={this.setFormApiDebit} className="">
                                                                        {({ formState, formApi }) => (
                                                                            <>
                                                                                <div className="net-search d-flex">
                                                                                    <div className="net-search-icon">
                                                                                        <BiSearch />
                                                                                    </div>
                                                                                    <div className="net-search-input">
                                                                                        <Text
                                                                                            type="text"
                                                                                            field="debitsearch"
                                                                                            className=" form-control-sm text-field-style SearchBox w-100"
                                                                                            placeholder="Search Your Bank"
                                                                                            onChange={() => {
                                                                                                this.setState({ isOpenDebit: true });
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <Collapse
                                                                                    activeKey={this.state.isOpenDebit ? ["1"] : ["0"]}
                                                                                    onChange={() => {
                                                                                        this.setState((prev) => ({ isOpenDebit: !prev.isOpenDebit }));
                                                                                    }}
                                                                                    expandIconPosition={"right"}
                                                                                >
                                                                                    <Panel
                                                                                        header={
                                                                                            this.state.selectedDebitBank ? (
                                                                                                <>
                                                                                                    <input type="radio" value={selectedDebitBankId} checked /> {selectedDebitBank}
                                                                                                </>
                                                                                            ) : (
                                                                                                "Choose Your Bank"
                                                                                            )
                                                                                        }
                                                                                        key="1"
                                                                                    >
                                                                                        <div className="net-list">
                                                                                            <RadioGroup field="DebitBanking" className="net-radio-group">
                                                                                                {this.state.DebitBankingList?.filter((bank) => bank.DataAccept !== selectedDebitBankId).map((bank) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            {formState?.values?.debitsearch ? (
                                                                                                                <>
                                                                                                                    {bank.CardBankName.includes(formState?.values?.debitsearch) && (
                                                                                                                        <div
                                                                                                                            className="net-radio-list"
                                                                                                                            onClick={() => {
                                                                                                                                formApi.setValue("DebitBanking", bank.DataAccept);

                                                                                                                                this.setState({ selectedDebitBank: bank.CardBankName, selectedDebitBankId: bank.DataAccept, isOpenDebit: false });
                                                                                                                                formApi.setValue("debitsearch", "");
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <div
                                                                                                                        className="net-radio-list"
                                                                                                                        onClick={() => {
                                                                                                                            formApi.setValue("DebitBanking", bank.DataAccept);
                                                                                                                            this.setState({ selectedDebitBank: bank.CardBankName, selectedDebitBankId: bank.DataAccept, isOpenDebit: false });
                                                                                                                            formApi.setValue("debitsearch", "");
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </>
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </div>
                                                                                    </Panel>
                                                                                </Collapse>
                                                                                <div className="net-pay">
                                                                                    <div className="final-amount mb-4 mr-3">
                                                                                        <span className="f-amount">₹ {PaymentData?.TotalAmount}</span>
                                                                                        <sub className="pay-now"> To Pay</sub>
                                                                                    </div>
                                                                                    <button
                                                                                        disabled={formState?.values?.DebitBanking ? false : true}
                                                                                        className="pay-now-btn upi-btn btn btn-success mb-4 mt-1"
                                                                                        onClick={() => {
                                                                                            this.proceedToPay("DEBIT");
                                                                                        }}
                                                                                        type="submit"
                                                                                    >
                                                                                        Proceed to pay
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </Form>
                                                                </Skeleton>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="tab-pane" id="c">
                                                        <div className="net-banking-container">
                                                            <div className="net-banking-form ">
                                                                <Skeleton active loading={this.state.loadingCredit}>
                                                                    <Form
                                                                        id="atm-form"
                                                                        getApi={this.setFormApiCredit}
                                                                        className=""
                                                                        // initialValues={

                                                                        // }
                                                                        onSubmit={this.SelectedCreditBanking}
                                                                    >
                                                                        {({ formState, formApi }) => (
                                                                            <>
                                                                                <div className="net-search d-flex">
                                                                                    <div className="net-search-icon">
                                                                                        <BiSearch />
                                                                                    </div>
                                                                                    <div className="net-search-input">
                                                                                        <Text
                                                                                            type="text"
                                                                                            field="creditsearch"
                                                                                            className=" form-control-sm text-field-style SearchBox w-100"
                                                                                            placeholder="Search Your Bank"
                                                                                            onChange={() => {
                                                                                                this.setState({ isOpenCredit: true });
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                <Collapse
                                                                                    activeKey={this.state.isOpenCredit ? ["1"] : ["0"]}
                                                                                    onChange={() => {
                                                                                        this.setState((prev) => ({ isOpenCredit: !prev.isOpenCredit }));
                                                                                    }}
                                                                                    expandIconPosition={"right"}
                                                                                // defaultActiveKey={["1"]}
                                                                                >
                                                                                    <Panel
                                                                                        header={
                                                                                            this.state.selectedCreditBank ? (
                                                                                                <>
                                                                                                    <input type="radio" value={selectedCreditBankId} checked /> {selectedCreditBank}
                                                                                                </>
                                                                                            ) : (
                                                                                                "Choose Your Bank"
                                                                                            )
                                                                                        }
                                                                                        key="1"
                                                                                    >
                                                                                        <div className="net-list">
                                                                                            <RadioGroup field="CreditBanking" className="net-radio-group">
                                                                                                {this.state.CreditBankingList?.filter((bank) => bank.DataAccept !== selectedCreditBankId).map((bank) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            {formState?.values?.creditsearch ? (
                                                                                                                <>
                                                                                                                    {bank.CardBankName.includes(formState?.values?.creditsearch) && (
                                                                                                                        <div
                                                                                                                            className="net-radio-list"
                                                                                                                            onClick={() => {
                                                                                                                                formApi.setValue("CreditBanking", bank.DataAccept);

                                                                                                                                this.setState({ isOpenCredit: false, selectedCreditBank: bank.CardBankName, selectedCreditBankId: bank.DataAccept });
                                                                                                                                formApi.setValue("creditsearch", "");

                                                                                                                                // setTimeout(() => {
                                                                                                                                //   formApi.setValue("creditsearch", "");
                                                                                                                                // }, 1000);
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                </>
                                                                                                            ) : (
                                                                                                                <>
                                                                                                                    <div
                                                                                                                        className="net-radio-list"
                                                                                                                        onClick={() => {
                                                                                                                            formApi.setValue("CreditBanking", bank.DataAccept);

                                                                                                                            this.setState({ isOpenCredit: false, selectedCreditBank: bank.CardBankName, selectedCreditBankId: bank.DataAccept });
                                                                                                                            formApi.setValue("creditsearch", "");
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}
                                                                                                        </>
                                                                                                    );
                                                                                                })}
                                                                                            </RadioGroup>
                                                                                        </div>
                                                                                    </Panel>
                                                                                </Collapse>

                                                                                <div className="net-pay">
                                                                                    <div className="final-amount mb-4 mr-3">
                                                                                        <span className="f-amount">₹ {PaymentData?.TotalAmount}</span>
                                                                                        <sub className="pay-now"> To Pay</sub>
                                                                                    </div>
                                                                                    <button
                                                                                        disabled={formState?.values?.CreditBanking ? false : true}
                                                                                        className="pay-now-btn upi-btn btn btn-success mb-4 mt-1"
                                                                                        onClick={() => {
                                                                                            this.proceedToPay("CREDIT");
                                                                                        }}
                                                                                        type="submit"
                                                                                    >
                                                                                        Proceed to pay
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </Form>
                                                                </Skeleton>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="tab-pane active" id="d">
                                                        <div className="net-banking-container">
                                                            <div className="net-banking-form ">
                                                                <Skeleton active loading={this.state.loadingNet}>
                                                                    <Form
                                                                        id="atm-form"
                                                                        getApi={this.setFormApiNet}
                                                                        className=""
                                                                        initialValues={{ NetBanking: selectedNetBankId }}
                                                                    // onSubmit={this.SelectedNetBanking}
                                                                    >
                                                                        {({ formState, formApi }) => (
                                                                            <>
                                                                                <div className="net-search d-flex">
                                                                                    <div className="net-search-icon">
                                                                                        <BiSearch />
                                                                                    </div>
                                                                                    <div className="net-search-input">
                                                                                        <Text type="text" field="netsearch" className=" form-control-sm text-field-style SearchBox w-100" placeholder="Search Your Bank" />
                                                                                    </div>
                                                                                </div>

                                                                                {this.state.NetBankingList?.filter((bank) => {
                                                                                    return formState?.values?.netsearch ? bank.CardBankName.includes(formState?.values?.netsearch) : bank;
                                                                                }).length > 0 ? (
                                                                                    <>
                                                                                        {selectedNetBank && !isOpenNet && !formState?.values?.netsearch ? (
                                                                                            <>
                                                                                                <div className="net-list mb-4">
                                                                                                    <div className="net-radio-list">
                                                                                                        <input type="radio" value={selectedNetBankId} checked /> {selectedNetBank}
                                                                                                    </div>
                                                                                                </div>

                                                                                                <>
                                                                                                    <div
                                                                                                        className="view-all"
                                                                                                        onClick={() =>
                                                                                                            this.setState((prev) => {
                                                                                                                return {
                                                                                                                    isOpenNet: !prev.isOpenNet,
                                                                                                                };
                                                                                                            })
                                                                                                        }
                                                                                                    >
                                                                                                        <BiPlus />
                                                                                                        View all banks
                                                                                                    </div>
                                                                                                </>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <RadioGroup field="NetBanking" className="net-radio-group">
                                                                                                    {this.state.NetBankingList?.slice(0, 5).filter((bank) => {
                                                                                                        return formState?.values?.netsearch ? bank.CardBankName.includes(formState?.values?.netsearch) : bank;
                                                                                                    }).length > 0 ? (
                                                                                                        <>
                                                                                                            <div className="net-list mb-4">
                                                                                                                {this.state.NetBankingList?.slice(0, 5).map((bank) => {
                                                                                                                    return (
                                                                                                                        <>
                                                                                                                            {formState?.values?.netsearch ? (
                                                                                                                                <>
                                                                                                                                    {bank.CardBankName.includes(formState?.values?.netsearch) && (
                                                                                                                                        <div
                                                                                                                                            className="net-radio-list"
                                                                                                                                            onClick={() => {
                                                                                                                                                formApi.setValue("NetBanking", bank.DataAccept);
                                                                                                                                                formApi.setValue("netsearch", "");

                                                                                                                                                this.setState({ selectedNetBank: bank.CardBankName, selectedNetBankId: bank.DataAccept, isOpenNet: false });
                                                                                                                                            }}
                                                                                                                                        >
                                                                                                                                            <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                                        </div>
                                                                                                                                    )}
                                                                                                                                </>
                                                                                                                            ) : (
                                                                                                                                <>
                                                                                                                                    <div
                                                                                                                                        className="net-radio-list"
                                                                                                                                        onClick={() => {
                                                                                                                                            formApi.setValue("NetBanking", bank.DataAccept);
                                                                                                                                            formApi.setValue("netsearch", "");

                                                                                                                                            this.setState({ selectedNetBank: bank.CardBankName, selectedNetBankId: bank.DataAccept, isOpenNet: false });
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                                    </div>
                                                                                                                                </>
                                                                                                                            )}
                                                                                                                        </>
                                                                                                                    );
                                                                                                                })}
                                                                                                            </div>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <></>
                                                                                                    )}

                                                                                                    {/*  to seprate first 5 banks */}
                                                                                                    {this.state.NetBankingList?.length > 5 && selectedNetBank == "" && !isOpenNet && !formState?.values?.netsearch && (
                                                                                                        <>
                                                                                                            <div
                                                                                                                className="view-all"
                                                                                                                onClick={() =>
                                                                                                                    this.setState((prev) => {
                                                                                                                        return {
                                                                                                                            isOpenNet: !prev.isOpenNet,
                                                                                                                        };
                                                                                                                    })
                                                                                                                }
                                                                                                            >
                                                                                                                <BiPlus />
                                                                                                                View all banks
                                                                                                            </div>
                                                                                                        </>
                                                                                                    )}

                                                                                                    {(isOpenNet || formState?.values?.netsearch) && (
                                                                                                        <div className="net-list mt-3">
                                                                                                            {this.state.NetBankingList?.slice(5, NetBankingList?.length).map((bank) => {
                                                                                                                return (
                                                                                                                    <>
                                                                                                                        {formState?.values?.netsearch ? (
                                                                                                                            <>
                                                                                                                                {bank.CardBankName.includes(formState?.values?.netsearch) && (
                                                                                                                                    <div
                                                                                                                                        className="net-radio-list"
                                                                                                                                        onClick={() => {
                                                                                                                                            formApi.setValue("NetBanking", bank.DataAccept);
                                                                                                                                            formApi.setValue("netsearch", "");

                                                                                                                                            this.setState({ selectedNetBank: bank.CardBankName, selectedNetBankId: bank.DataAccept, isOpenNet: false });
                                                                                                                                        }}
                                                                                                                                    >
                                                                                                                                        <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                                    </div>
                                                                                                                                )}
                                                                                                                            </>
                                                                                                                        ) : (
                                                                                                                            <>
                                                                                                                                <div
                                                                                                                                    className="net-radio-list"
                                                                                                                                    onClick={() => {
                                                                                                                                        formApi.setValue("NetBanking", bank.DataAccept);
                                                                                                                                        formApi.setValue("netsearch", "");

                                                                                                                                        this.setState({ selectedNetBank: bank.CardBankName, selectedNetBankId: bank.DataAccept, isOpenNet: false });
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    <Radio value={bank.DataAccept} /> {bank.CardBankName}
                                                                                                                                </div>
                                                                                                                            </>
                                                                                                                        )}
                                                                                                                    </>
                                                                                                                );
                                                                                                            })}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </RadioGroup>
                                                                                            </>
                                                                                        )}

                                                                                        <div className="net-pay">
                                                                                            <div className="final-amount mb-4 mr-3">
                                                                                                <span className="f-amount">₹ {PaymentData?.TotalAmount}</span>
                                                                                                <sub className="pay-now"> To Pay</sub>
                                                                                            </div>
                                                                                            <button
                                                                                                disabled={selectedNetBankId !== "" ? false : true}
                                                                                                className="pay-now-btn upi-btn btn btn-success mb-4 mt-1"
                                                                                                onClick={() => {
                                                                                                    this.proceedToPay("NET");
                                                                                                }}
                                                                                                type="submit"
                                                                                            >
                                                                                                Proceed to pay
                                                                                            </button>
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="nodata">
                                                                                            <div className="oops">Oops!</div>
                                                                                            <div className="nodata-msg">We could'nt find your bank</div>
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </Form>
                                                                </Skeleton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="booking-detail">
                                {PaymentData?.PaymentType === "Reschedule" && (
                                    <>
                                        {" "}
                                        <div className="booking-detail-summary pt-4">
                                            <h4 className="mb-2 b-detail">Reschedule Summary</h4>
                                            <div className="boat-charges d-flex flex-column p-4">
                                                <div className="boat-charges-data d-flex">
                                                    <div className="charge-name">Reschedule Charges</div>
                                                    <div className="charges">₹ {parseFloat(PaymentData?.RescheduleData?.RescheduleAmount).toFixed(2)} </div>
                                                </div>
                                                <div className="boat-charges-data d-flex">
                                                    <div className="charge-name"> GST</div>
                                                    <div className="charges">₹ {parseFloat(PaymentData?.RescheduleData?.RescheduleGST).toFixed(2)} </div>
                                                </div>

                                                <div className="total-charges-data d-flex">
                                                    <div className="total-charge-name">Net Amount</div>

                                                    <div className="total-amount"> ₹ {parseFloat(PaymentData?.RescheduleData?.RescheduleNetAmount).toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {PaymentData?.PaymentType === "Booking" && (
                                    <>
                                        <div className="booking-detail-summary pt-4">
                                            <h4 className="mb-2 b-detail">Booking Summary</h4>
                                            {/* <div className="user-info">
                  <span className="mail">test@gmail.com</span>
                  <span className="mobile">9876543210</span>
                </div> */}
                                            <div className="boat-detail">
                                                <div className="boat-summary d-flex flex-column">
                                                    {PaymentData?.BoatData?.ticketCart?.map((boatcart) => {
                                                        return (
                                                            <>
                                                                <div className=" boat-data  d-flex mb-4">
                                                                    <div className="boat-name col-md-5 p-0 ">
                                                                        <span className="">{boatcart.BoatType}</span>
                                                                        <span className="small-font">
                                                                            {boatcart.SeaterType}
                                                                            <span className=" colorticket"> {boatcart.SlotType}</span>
                                                                        </span>
                                                                        <span className="small-font colorticket">
                                                                            {boatcart?.Timeslot?.SlotStartTime}
                                                                            {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                                                        </span>
                                                                    </div>

                                                                    <div className="boat-count d-flex justify-content-center col-md-3">
                                                                        <span className="btn">{boatcart.count} Ticket(s)</span>
                                                                    </div>
                                                                    <div className="boat-price col-md-4 text-right">
                                                                        <span className="">₹{parseInt((parseFloat(boatcart.NTBoatTotalCharge || 0) + parseFloat(boatcart.NTdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                    {PaymentData?.BoatData?.boatCart?.map((boatcart) => {
                                                        return (
                                                            <>
                                                                <div className=" boat-data  d-flex mb-4">
                                                                    <div className="boat-name col-md-5 p-0 ">
                                                                        <span className="">{boatcart.BoatType}</span>
                                                                        <span className="small-font">
                                                                            {boatcart.SeaterType}
                                                                            <span className=" colorgreen"> {boatcart.SlotType}</span>
                                                                        </span>
                                                                        <span className="small-font colorgreen" style={{color:'green'}}>
                                                                            {boatcart?.Timeslot?.SlotStartTime}
                                                                            {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                                                        </span>
                                                                    </div>

                                                                    <div className="boat-count d-flex justify-content-center col-md-3">
                                                                        <span className="btn">{boatcart.count} Boat(s)</span>
                                                                    </div>
                                                                    <div className="boat-price col-md-4 text-right">
                                                                        <span className="">₹{parseInt((parseFloat(boatcart.BoatTotalCharge || 0) + parseFloat(boatcart.NBdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                    {PaymentData?.BoatData?.ExpressboatCart?.map((boatcart) => {
                                                        return (
                                                            <>
                                                                <div className=" boat-data  d-flex mb-4">
                                                                    <div className="boat-name col-md-5 p-0 ">
                                                                        <span className="">{boatcart.BoatType}</span>
                                                                        <span className="small-font">
                                                                            {boatcart.SeaterType}
                                                                            <span className=" colororange"> {boatcart.SlotType}</span>
                                                                        </span>
                                                                        <span className="small-font colororange">
                                                                            {boatcart?.Timeslot?.SlotStartTime}
                                                                            {/* to {boatcart?.Timeslot?.SlotEndTime} */}
                                                                        </span>
                                                                    </div>

                                                                    <div className="boat-count d-flex justify-content-center col-md-3">
                                                                        <span className="btn">{boatcart.count} Boat(s)</span>
                                                                    </div>
                                                                    <div className="boat-price col-md-4 text-right">
                                                                        <span className="">₹{parseInt((parseFloat(boatcart.ECBoatTotalCharge || 0) + parseFloat(boatcart.ECdepositeCharge || 0)) * parseFloat(boatcart.count || 0))}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                    {PaymentData?.BoatData?.EntranceCart?.map((service) => {
                                                        return (
                                                            <>
                                                                <div className=" boat-data  d-flex mb-2">
                                                                    <div className="boat-name col-md-5 p-0 ">
                                                                        <span className=""> {service.CategoryName}</span>
                                                                        <span className="small-font">{service.ServiceName}</span>
                                                                    </div>

                                                                    <div className="boat-count d-flex justify-content-center col-md-3">
                                                                        <span className="btn">{service.count}</span>
                                                                    </div>
                                                                    <div className="boat-price col-md-4 text-right">
                                                                        <span className="">₹ {parseInt((service.ServiceTotalAmount || 0) * service.count)}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                    {PaymentData?.BoatData?.OtherserviceCart?.map((service) => {
                                                        return (
                                                            <>
                                                                <div className=" boat-data  d-flex mb-2">
                                                                    <div className="boat-name col-md-5 p-0 ">
                                                                        <span className=""> {service.CategoryName}</span>
                                                                        <span className="small-font">{service.ServiceName}</span>
                                                                    </div>

                                                                    <div className="boat-count d-flex justify-content-center col-md-3">
                                                                        <span className="btn">{service.count}</span>
                                                                    </div>
                                                                    <div className="boat-price col-md-4 text-right">
                                                                        <span className="">₹ {parseInt((service.ServiceTotalAmount || 0) * service.count)}</span>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                </div>
                                                <hr />
                                                <div className="boat-charges d-flex flex-column">
                                                    <div className="boat-charges-data d-flex">
                                                        <div className="charge-name">Boat Charges</div>
                                                        <div className="charges">₹ {parseFloat(PaymentData?.BoatData?.BoatAmount).toFixed(2)} </div>
                                                    </div>

                                                    {PaymentData?.BoatData?.RowerCharge === "00.00" ? (
                                                        ""
                                                    ) : (
                                                        <div className="boat-charges-data d-flex">
                                                            <div className="charge-name">Rower Charges</div>

                                                            <div className="charges">₹ {parseFloat(PaymentData?.BoatData?.RowerCharge).toFixed(2)}</div>
                                                        </div>
                                                    )}

                                                    <div className="boat-charges-data d-flex">
                                                        <div className="charge-name">GST</div>

                                                        <div className="charges">₹{parseFloat(PaymentData?.BoatData?.BoatTaxAmount).toFixed(2)}</div>
                                                    </div>

                                                    {PaymentData?.BoatData?.DepositeAmount === 0 ? (
                                                        ""
                                                    ) : (
                                                        <div className="boat-charges-data d-flex">
                                                            <div className="charge-name">Deposit</div>

                                                            <div className="charges">₹ {parseFloat(PaymentData?.BoatData?.DepositeAmount).toFixed(2)} </div>
                                                        </div>
                                                    )}

                                                    {(PaymentData?.BoatData?.OtherserviceCart?.length > 0 || PaymentData?.BoatData?.EntranceCart?.length > 0) && (
                                                        <>
                                                            <div className="boat-charges-data d-flex">
                                                                <div className="charge-name">Other Facilities</div>

                                                                <div className="charges">₹ {parseFloat(PaymentData?.BoatData?.ServiceTotalAmount - PaymentData?.BoatData?.ServiceTaxAmount).toFixed(2)} </div>
                                                            </div>

                                                            <div className="boat-charges-data d-flex">
                                                                <div className="charge-name">GST</div>

                                                                <div className="charges">₹ {parseFloat(PaymentData?.BoatData?.ServiceTaxAmount).toFixed(2)} </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                                <hr />
                                                <div className="total-charges-data d-flex">
                                                    <div className="total-charge-name">Total Amount</div>

                                                    <div className="total-amount"> ₹ {parseFloat(PaymentData?.BoatData?.TotalAmount).toFixed(2)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <>
                        <Modal centered isOpen={this.state.isAlertModal} className={"alert-model"}>
                            <p className="text-center payment-alert mt-5 mb-4">Payment Session is timed out !</p>
                            <div className="d-flex justify-content-center mt-3 mb-5">
                                <button className=" go-back-btn btn btn-success" onClick={this.GoBack}>
                                    Go Back
                                </button>
                            </div>
                        </Modal>
                    </>
                    <>
                        <Modal centered isOpen={this.state.isUpiModel} className={"alert-model"}>
                            <ModalHeader>TTDC</ModalHeader>
                            <ModalBody>

                                {this.state.Time !== "" && this.state.PaymentState === false ? (
                                    <div className="timerdiv " style={{ width: "100%", height: "100%" }}>
                                        <Row>
                                            <span style={{ marginLeft: "8rem", marginBottom: "1rem" }}>Payment Session will expire in </span>
                                            <span className="timercount" style={{ marginLeft: "8rem" }}>
                                                {/* {console.log('time', this.state.Time)} */}
                                                < CountdownCircleTimer
                                                    key={this.state.key}
                                                    isPlaying
                                                    // duration={this.state.Time/1000} 
                                                    duration={240}
                                                    colors={['#32DC2C', '#95E123', '#E9D02F', '#E21F1F']}
                                                    colorsTime={[this.state.Time / 1000, ((this.state.Time / 1000) * 0.50), ((this.state.Time / 1000) * 0.25), 0]}
                                                    children={this.circularTimeConvert} onComplete={this.circularTimeComplete}
                                                />
                                                {/* <Countdown date={Date.now() + Number(this.state.Time)} renderer={this.Timerenderer} /> */}
                                            </span>
                                            <p style={{ marginTop: "2rem", color: "orange" }}>Note: Please Do not Close/Refresh this Window, It will interupts the payment session and you may need to book again.</p>
                                        </Row>
                                        {this.state.resendButton === true &&
                                            <div className="d-flex justify-content-end mt-5 mb-0">
                                                <button className=" btn btn-primary px-4 " onClick={this.sendUPImsg}>
                                                    Resend
                                                </button>
                                            </div>}
                                    </div>
                                ) : (
                                    ""
                                )}
                                {/* {this.state.showQr === true && this.state.PaymentState ===false && <QRCode
                        value={this.state.qrLink}
                        logoImage={qrpng}
                        // removeQrCodeBehindLogo ={true}
                        />} */}
                                {/* { this.state.showQr === false && this.state.PaymentState === false &&
                  <div className="d-flex justify-content-end mt-5 mb-0">
                  
                    <button className=" btn btn-primary px-4 " onClick={this.showQrFun}>
                      Genrate QR
                    </button>
                  </div>} */}

                                {/* {
                    this.state.PaymentState === true && <div >
                      <Row style={{height:"100%", width:"100%",}}>

                          <Col className="mt-2">
                            <img src={successIcon} style={{height:"50px", width:"50px",marginLeft:"3rem" }} />  
                            
                          </Col>

                          <Col className="mt-8">
                            <p  style={{ fontSize: "20px", fontWeight: "500",width:"100%",height:"100%",marginRight:"11rem",marginTop:"1rem",
                             }}  > Payment Done Successfully...  </p> 
                            
                          </Col>
                          
                      </Row>
                    </div>
                  } */}
                                {/* <p className="text-center  mt-5 mb-4" style={{ fontSize: "20px", fontWeight: "500" }}> */}
                                {/* Payment Link Send Successfully */}
                                {/* {this.state.isUpiSmsSend ? "Payment Sent Successfully... " : "SMS Not Send! "} */}
                                {/* </p> */}

                                {/* <div className="d-flex justify-content-end mt-5 mb-0">
                <button className=" btn btn-primary px-4 " onClick={this.upiOk}>
                  OK
                </button>
              </div> */}
                            </ModalBody>
                        </Modal>
                    </>
                </div>
            </div>
        );
    }
}
